<nav class="navbar navbar-expand-lg navbar-dark bg-primary mb-3">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#barraNavegacion"
    aria-controls="barraNavegacion" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="barraNavegacion">
    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link" href="#somos" (click)="scrolling('somos')">¿Quiénes somos?</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#historia" (click)="scrolling('historia')">Nuestra historia</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#trabajo" (click)="scrolling('trabajo')">Nuestro trabajo</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#ayuda" (click)="scrolling('ayuda')">Ayuda</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#contacto" (click)="scrolling('contacto')">Contacto</a>
      </li>
    </ul>
  </div>
</nav>
